import API from '@/api';
import moment from 'moment';
import 'moment-timezone';
// import moment from 'moment';
const Consultation = API.get('Consultation');
const Cases = API.get('Cases');

export default ({
  namespaced: true,
  state: {
    consultations: [],
    activeIndex: null,
    activeInfo: null,
    last_page: null,
    filteredConsultations: []
  },

  /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

  getters: {
    consultations: state => state.consultations,
    activeIndex: state => state.activeIndex,
    documents: state => state.activeInfo.documents,
    last_page: state => state.last_page,
    
    activeInfo: state => state.activeInfo,
    
    filteredConsultations: state => {
      // return state.consultations.filter(item => item.status == 'ongoing')
      console.log(state.consultations);
      return state.consultations
    }
  },

  /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

  mutations: {
    setConsultations(state, consultations) {
      consultations.sort((a, b) => {
        return moment(a.call_datetime).diff(moment(b.call_datetime));
      });
      state.consultations = consultations
    },

    /*setLatestConsultationRequest(state, request) {

      console.log("consultation state: ", state);
      console.log("request: ", request);

      console.log("state.consultations: ", state.consultations);
      console.log("state.activeIndex: ", state.activeIndex);
      console.log("active consultation request: ", state.consultations[state.activeIndex]);
      
      let requests_length = 0
      
      if(state.activeIndex != null) {
        if(state.consultations[state.activeIndex].hasOwnProperty('requests')) {
          requests_length = state.consultations[state.activeIndex].requests.length;
        }
      }
      
      if(requests_length == 0) {
        requests_length = 1;
      }

      state.consultations[state.activeIndex].requests[requests_length - 1] = request;
    },*/

    /* ############################## MUTATION SEPARATOR ############################## */

    setLatestConsultationRequest(state, request) {
      console.log("setLatestConsultationRequest");
      console.log("consultation state: ", state);
      console.log("request: ", request);
      console.log("state.consultations: ", state.consultations);
      console.log("state.activeIndex: ", state.activeIndex);
      
      if (state.activeIndex == null || !Array.isArray(state.consultations) || !state.consultations[state.activeIndex]) {
        console.error("Invalid activeIndex or consultations array.");
        return;
      }

      delete request.case;
      delete request.consultation;
      delete request.doctor;
      delete request.patient;

      state.consultations[state.activeIndex].requests = request;
      console.log("consultation_request", state.consultations[state.activeIndex]);
    },

    /* ############################## MUTATION SEPARATOR ############################## */

    setActive(state, index) {
      state.activeIndex = index
      state.activeInfo = state.consultations[state.activeIndex];
      console.log("[activeInfo]", state.activeInfo);
    },

    /* ############################## MUTATION SEPARATOR ############################## */

    setActiveConsultation(state, consultation) {
      console.log("[setActiveConsultation from sidebar]");

      if(state.consultations[state.activeIndex]?.id) {
        if(state.consultations[state.activeIndex].id == consultation.id) {
          if(state.consultations[state.activeIndex].requests && (state.consultations[state.activeIndex].requests.case_consultation_id == consultation.id)) {
            consultation.requests = state.consultations[state.activeIndex].requests;
          }
        }
      }

      state.consultations[state.activeIndex] = consultation;
      state.activeInfo = consultation;
      console.log("[activeInfo]", state.activeInfo);
    },

    /* ############################## MUTATION SEPARATOR ############################## */

    pushNewConsultation(state, consultation) {
      state.consultations.unshift(consultation.consultation)
      console.log(
        "SOCKET_DEBUG",
        "New case list",
        {
          caseList: state.consultations
        }
      )
    },

    /* ############################## MUTATION SEPARATOR ############################## */

    setLastPage(state, page) {
      state.last_page = page
    },
  },

  /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

  actions: {
    async fetchConsultations(state, {id=null, doctor=null, today=null, status=null, page=null}) {
      var response = await Consultation.get(id, doctor, today, status, page);

      console.log("consultation api call");
      console.log(response);

      var sortedResponse = response.data.data.sort((a,b) => a.call_datetime.valueOf() - b.call_datetime.valueOf() );
      sortedResponse.reverse();
      state.commit('setConsultations', sortedResponse)
      state.commit('setLastPage', response.data.last_page)
    },

    /* ############################## API CALL SEPARATOR ############################## */

    // fetch consultation and add to consultations object
    async fetchConsultation(state, {id=null, patient=null, no_info=false}) {
      let response = await Consultation.get(id);
      if (patient !== null)
        response.data.patient = await patient
      if (no_info) {
        let info = await Cases.get(patient.patient_case_id);
        response.data.case = await info.data
      }
      console.log('response', response.data)
      state.commit('pushNewConsultation', response.data)
    },

    /* ############################## API CALL SEPARATOR ############################## */

    async fetchConsultationFromList(state, {caseId=null, id=null, doctor=null, today=null, status=null}) {
      var response = await Consultation.get(id, doctor, today, status);
      var index = response.data.data.findIndex(item => item.id == caseId)
      var item = response.data.data[index]
      if (index >= 0) {
        state.commit('pushNewConsultation', item)
      }
    },

    /* ############################## API CALL SEPARATOR ############################## */

    /**
     * Save case status
     * 1. Complete  - case ongoing / consultation complete
     * 2. Save only - case ongoing / consultation ongoing
     * 3. For Transfer - case pending / consultation pending
     */
    async updateStatus(state, {id, status}) {
      const payload = {
        status: status
      }
      if (status == 'pending')
        payload.doctor_id = null
      let response = await Consultation.update(id, payload);
      console.log("[consultation/updateStatus]", response);
    },

    /* ############################## API CALL SEPARATOR ############################## */

    async updateStartDate(state, {id}) {
      console.log("[state consultation]", state);
      let user = JSON.parse(localStorage.getItem('user'))

      let current_moment_data = moment();
      let current_full_date = current_moment_data.clone().tz("Asia/Manila").format('YYYY-MM-DD HH:mm:ss');
      console.log("[current_full_date]", current_full_date);

      const payload = {
        started_at: current_full_date
      }
      
      payload.doctor_id = user.id;
      let response = await Consultation.update(id, payload);
      response.data.started_at = current_full_date;

      console.log("[consultation update]", response.data);
      state.commit('setActiveConsultation', response.data);
      return response.data;
    },
  }
})